import React from 'react';
import './DisclaimerPage.css';
import Navbar from '../components/navbar';
import CTAButton from '../components/sticky-button';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

const DisclaimerPage = () => {
  return (
      <>
      <Navbar />
      <CTAButton />
         <PageHeader
                title="Disclaimer"
                crumbs={[{ label: 'Home', href: '/' }, { label: 'Disclaimer' }]}
              />
    <div className="tm-disc-wrapper">



      {/* Web Disclaimer Card */}
      <section className="tm-disc-card">
        <div className="tm-disc-card-body">
          <div className="tm-disc-card-icon-area">
            <div className="tm-disc-icon-circle">
              <svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                <path d="M2 12h20M16 16l2 2 4-4" />
              </svg>
            </div>
          </div>
          <div className="tm-disc-card-text-area">
            <h2 className="tm-disc-section-heading">Web Disclaimer</h2>
            <div className="tm-disc-accent-line"></div>
            <p className="tm-disc-paragraph">
              All information provided in <a href="http://www.timscdrmumbai.in" className="tm-disc-inline-link">www.timscdrmumbai.in</a> is provided for information purposes only and does not constitute a legal contract between the Institute and any person or entity unless otherwise specified. Information on <a href="http://www.timscdrmumbai.in" className="tm-disc-inline-link">www.timscdrmumbai.in</a> website is subject to change without prior notice. Although every reasonable effort is made to present current and accurate information, the Thakur Institute of Management Studies Career Development & Research makes no guarantee of any kind.
            </p>
            <p className="tm-disc-paragraph">
              The Thakur Institute of Management Studies Career Development & Research website may contain information that is created and maintained by a variety of sources both internal and external to the Institute. The copyrighted matters appearing on <a href="http://www.timscdrmumbai.in" className="tm-disc-inline-link">www.timscdrmumbai.in</a> belong to Thakur Institute of Management Studies Career Development & Research, and any reproduction or use of the same for gain or commercial utilization without prior written permission amounts to infringement of the copyrighted matters appearing on the above website, under Copyright Act, 1957.
            </p>
          </div>
        </div>
      </section>

      {/* E-mail Disclaimer Card */}
      <section className="tm-disc-card">
        <div className="tm-disc-card-body">
          <div className="tm-disc-card-icon-area">
            <div className="tm-disc-icon-circle">
              <svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
                <rect x="16" y="14" width="6" height="8" rx="1" strokeWidth="2" />
              </svg>
            </div>
          </div>
          <div className="tm-disc-card-text-area">
            <h2 className="tm-disc-section-heading">E-mail Disclaimer</h2>
            <div className="tm-disc-accent-line"></div>
            <p className="tm-disc-paragraph">
              The information contained in the email of <strong>username@thakureducation.org</strong> is confidential and may contain proprietary information. It is meant solely for the intended recipient. Access to this email by anyone else is unauthorized. If you are not the intended recipient, any disclosure, copying, distribution or any action taken or omitted in reliance on this, is prohibited and would be unlawful. No liability or responsibility is accepted if information or data is, for whatever reason corrupted or does not reach its intended recipient.
            </p>
            <p className="tm-disc-paragraph">
              If you have received this message in error, please notify the sender immediately, and delete this email from your system. No warranty is given that this email is free of viruses.
            </p>
            <p className="tm-disc-paragraph">
              The views expressed in this email are, unless otherwise stated, those of the author and not those of Thakur Education Group or its management. Thakur Education Group reserves the right to monitor, intercept and block emails addressed to its users or take any other action in accordance with its email use policy.
            </p>
            
            <div className="tm-disc-inquiry-box">
              <div className="tm-disc-alert-icon-small">!</div>
              <p>
                If you consider the contents of the mails inappropriate or as spam, please forward this mail to <a href="mailto:spam@thakureducation.org" className="tm-disc-inline-link">spam@thakureducation.org</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Footer */}
   
    </div>
          <Footer />
    </>
  );
};

export default DisclaimerPage;